<template>
  <div class="match_area">
    <h3 class="title">주요경기</h3>
    <div id="match_list" class="match_list swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide item" v-for="item in matchData" :key="item.matchId">
          <div class="league">{{ item.snm }} - {{ item.lnm }}</div>
          <div class="time">{{ item.matchdate }}</div>
          <a class="team_area" :href="`/game/game.php?type=0&${queryString(item.sportsid, item.omatchid, item.regionid, item.competitionid)}`" onclick="gaEventer('메인 - 주요경기', '경기')">
            <span class="team left">{{ item.hTeamNm }}</span>
            <span class="vs">VS</span>
            <span class="team right">{{ item.aTeamNm }}</span>
          </a>
          <a :href="`/game/game.php?type=0&${queryString(item.sportsid, item.omatchid, item.region, item.competition)}`" onclick="gaEventer('메인 - 주요경기', '경기')">
            <div class="odds">
              <dl><dt>{{ aliasType(item.outcome[0].kind) }}</dt><dd><span>{{ lastZeroRemover(item.outcome[0].price / 1) }}</span></dd></dl>
              <dl><dt>{{ aliasType(item.outcome[1].kind) }}</dt><dd><span>{{ lastZeroRemover(item.outcome[1].price / 1) }}</span></dd></dl>
              <dl v-if="item.mnm === '승무패'"><dt>{{ aliasType(item.outcome[2].kind) }}</dt><dd><span>{{ lastZeroRemover(item.outcome[2].price / 1) }}</span></dd></dl>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "popular-match",
    props: ['matchData'],
    methods: {
      initSwiperMatch: function() {
        this.swiper = new Swiper('#match_list', {
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          }
        });
      },
      aliasType(str) {
        const type = {
          "W1": "승",
          "X": "무",
          "W2": "패"
        }
        return type[str]
      },
      lastZeroRemover(str) {
        const temp = str.toFixed(3);
        return temp.slice(-1) === '0'
            ? temp.slice(0, -1)
            : temp;
      },
      queryString(...rest) {
        const matchInfo = ['sport', 'game', 'region', 'competition']
        return matchInfo.map((name, index) => `${name}=${rest[index] || 1}`)
            .reduce((a, b) => `${a}&${b}`)
      },
    },
    mounted() {
      setTimeout(() => {
        this.initSwiperMatch();
      }, 1000)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/main/popular-match.vue